export const SHADOW_PLACEMENT_TO_BOX_SHADOW_MAP = {
  insideLeft: `inset 
  min(var(--overflow-left), var(--blur))
  0
  var(--blur) 
  calc((-1 * var(--blur)) - 2px)
  var(--color)`,
  insideRight: `inset
  calc(max(-1 * var(--overflow-right), -1 * var(--blur)))
  0
  var(--blur)
  calc((-1 * var(--blur)) - 2px)
  var(--color)
  `,
  insideTop: `inset
  0
  min(var(--overflow-top), var(--blur))
  var(--blur)
  calc((-1 * var(--blur)) - 2px)
  var(--color)
  `,
  insideBottom: `inset
  0
  calc(max(-1 * var(--overflow-bottom), -1 * var(--blur)))
  var(--blur)
  calc((-1 * var(--blur)) - 2px)
  var(--color)
  `,
};
